import Swiper, {
  Pagination, Navigation, Lazy, EffectFade,
} from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class HeroCarousel extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-heroCarousel',
      prevArrow: '.js-heroCarouselPrev',
      nextArrow: '.js-heroCarouselNext',
      pagination: '.js-heroCarouselPagination',
      header: '.js-header',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$get(this.refs.prevArrow),
      $nextArrow: this.$get(this.refs.nextArrow),
      $pagination: this.$get(this.refs.pagination),
      $header: document.querySelector(this.refs.header),
    };

    this.state = {
      swiper: null,
      activeColor: '',
      revealClass: 'reveal',
      removeClass: 'remove',
      animationTiming: 500,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Pagination, Navigation, Lazy, EffectFade],
      init: false,
      preloadImages: false,
      speed: 1000,
      effect: 'fade',
      pagination: {
        el: dom.$pagination,
        clickable: true,
        bulletClass: 'HeroCarousel__bullet',
        bulletActiveClass: 'is-active-slide',
      },
      lazy: {
        loadOnTransitionStart: true,
      },
      breakpoints: {
        1024: {
          threshold: 35,
        },
      },
    });

    state.swiper.on('init', () => this.setNavigationColor());

    state.swiper.on('slideChange', () => this.setNavigationColor());

    state.swiper.init();
  }

  async getColor() {
    const { state } = this;

    const activeIndex = state.swiper.realIndex;
    const $activeSlide = state.swiper.slides[activeIndex];
    state.activeColor = $activeSlide.dataset.color;
  }

  setNavigationColor() {
    const { dom, state } = this;

    dom.$header.classList.remove(`is-${state.activeColor}`);
    this.getColor();
    dom.$header.classList.add(`is-${state.activeColor}`);
  }
}
